//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { InstagramDraftsModalAction } from '@instagram-account/redux/drafts/modal/instagramDraftsModalActions';
import { IInstagramDraftsModalState, INSTAGRAM_DRAFTS_MODAL_ACTIONS } from '@instagram-account/redux/drafts/modal/instagramDraftsModalModel';

const initialState: IInstagramDraftsModalState = {
  isDeleteDraftModalOpen: false,
};

export default function InstagramDraftsModalReducer(
  state: IInstagramDraftsModalState = initialState,
  action: InstagramDraftsModalAction,
): IInstagramDraftsModalState {
  switch (action.type) {
    case INSTAGRAM_DRAFTS_MODAL_ACTIONS.OPEN_DELETE_DRAFT_MODAL: {
      return {
        ...state,
        isDeleteDraftModalOpen: true,
        currentDraft: action.draft,
      };
    }
    case INSTAGRAM_DRAFTS_MODAL_ACTIONS.CLOSE_DELETE_DRAFT_MODAL: {
      return {
        ...state,
        isDeleteDraftModalOpen: false,
        currentDraft: undefined,
      };
    }
    default:
      return state;
  }
}
